import type { ChartMode, MetricKey } from '../type/dynamicChart';
import { metricRegistry } from '../registry/metrics';

const X_METRIC_EXCLUDE = new Set(['traceId', 'operator']);

export function buildXMetrics(mode: ChartMode): { value: MetricKey; label: string }[] {
  return metricRegistry
    .filter((m) => m.kind === 'categorical' && !X_METRIC_EXCLUDE.has(m.key))
    .filter((m) => m.key !== 'reference' || mode === 'comparison')
    .map((m) => ({ value: m.key as MetricKey, label: m.labelKey }));
}

export function buildHistogramXMetrics(mode: ChartMode): { value: MetricKey; label: string }[] {
  return metricRegistry
    .filter((m) => m.key === 'toolId' || (m.key === 'reference' && mode === 'comparison'))
    .map((m) => ({ value: m.key as MetricKey, label: m.labelKey }));
}

export function buildAllXMetrics(mode: ChartMode): { value: MetricKey; label: string }[] {
  return metricRegistry
    .filter((m) => !X_METRIC_EXCLUDE.has(m.key))
    .filter((m) => m.key !== 'reference' || mode === 'comparison')
    .map((m) => ({ value: m.key as MetricKey, label: m.labelKey }));
}

export function buildYMetrics(): { value: MetricKey; label: string }[] {
  return metricRegistry
    .filter((m) => m.kind === 'numeric')
    .map((m) => ({ value: m.key as MetricKey, label: m.labelKey }));
}
